import script from "./EducationConfirmView.vue?vue&type=script&lang=ts&setup=true"
export * from "./EducationConfirmView.vue?vue&type=script&lang=ts&setup=true"

import "./EducationConfirmView.vue?vue&type=style&index=0&id=27c19446&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27c19446"]])

export default __exports__